/**
 * メッセージタイプに応じた色を取得
 */
export const MESSAGE_TYPE_COLORS: Record<string, string> = {
  error: '#f44336',
  warning: '#ff9800',
  success: '#4caf50',
  info: '#2196f3',
} as const;

/**
 * タスクステータスに応じた色を取得
 */
export const TASK_STATUS_COLORS: Record<string, string> = {
  completed: '#4caf50',
  in_progress: '#2196f3',
  failed: '#f44336',
  pending: '#9e9e9e',
} as const;

/**
 * タスクステータステキストを取得
 */
export const TASK_STATUS_LABELS: Record<string, string> = {
  pending: '未着手',
  in_progress: '進行中',
  completed: '完了',
  failed: '失敗',
} as const;
